import { Skeleton, TableCell } from '@mui/material';

import useDateText, { DateTextVariants } from '@/hooks/useDateText';

type Props = {
  date: string | undefined | null;
  isLoading: boolean;
};

const DateCell = ({ date, isLoading }: Props) => {
  const { formatDateString } = useDateText();
  const formattedDate = date ? formatDateString(date, DateTextVariants.DAY_MONTH) : null;
  return (
    <TableCell align='right'>
      {isLoading && !date ? (
        <Skeleton
          variant='text'
          width={45}
          sx={{ ml: 'auto' }}
        />
      ) : (
        formattedDate
      )}
    </TableCell>
  );
};

export default DateCell;
